import { KNOWN_CHAIN_CURRENCY } from "./libs/useMetaMaskWallet/utils"
import Web3 from "web3"

// import AddressIcon from "../src/assets/icons/address-icon.png"
import EthereumIcon from "../src/assets/images/crypto/icons/ethereum.webp"
import ArbitrumIcon from "../src/assets/images/crypto/icons/arbitrum.png"
import ArbitrumNovaIcon from "../src/assets/images/crypto/icons/arbitrumnova.png"
import AvalancheIcon from "../src/assets/images/crypto/icons/avalanche.webp"
import MaticIcon from "../src/assets/images/crypto/icons/matic.webp"
import OKCIcon from "../src/assets/images/crypto/icons/okc.png"
import BinanceIcon from "../src/assets/images/crypto/icons/binance.png"
import FantomIcon from "../src/assets/images/crypto/icons/fantom.png"
import DogeIcon from "../src/assets/images/crypto/icons/dogechain.png"
import SolanaIcon from "../src/assets/images/crypto/icons/solana.png"
import MetamaskIcon from "../src/assets/images/crypto/icons/metamask.png"
import ZkSyncIcon from "../src/assets/images/crypto/icons/zksync.jpg"

const networkIcons = {
    Ethereum: EthereumIcon,
    Binance: BinanceIcon,
    Polygon: MaticIcon,
    Matic: MaticIcon,
    Avalanche: AvalancheIcon,
    Fantom: FantomIcon,
    Dogechain: DogeIcon,
    Solana: SolanaIcon,
    OKC: OKCIcon,
    Arbitrum: ArbitrumIcon,
    ArbitrumNova: ArbitrumNovaIcon,
    ZkSync: ZkSyncIcon,
    ZkSyncTestnet: ZkSyncIcon,

    ethereum: EthereumIcon,
    bnbchain: BinanceIcon,
    binance: BinanceIcon,
    BSC: BinanceIcon,
    polygon: MaticIcon,
    matic: MaticIcon,
    avalanche: AvalancheIcon,
    okc: OKCIcon,
    arbitrum: ArbitrumIcon,
    arbitrumnova: ArbitrumNovaIcon,
    zksync: ZkSyncIcon,
    zksynctest: ZkSyncIcon,
    fantom: FantomIcon,
    dogechain: DogeIcon,
    solana: SolanaIcon,
    metamask: MetamaskIcon
}

const convertTokenToNFTDetails = (data) => ({
    id: data?.id?.S,
    author: data?.author?.S,
    source: data?.source?.S,
    step: data?.step?.S,
    wallet: data?.wallet?.S,
    token_id: data?.token_id?.N,
    inserted: data?.inserted?.N
})

const convertTradingTokenToNFTDetails = (data) => ({
    id: data.id["S"],
    author: data.author["S"],
    source: data.source["S"],
    step: data.step["S"],
    wallet: data.wallet["S"],
    token_id: data.token_id["N"],
    inserted: data.inserted["N"],
    updated: data.updated["N"],
    price: data.price["N"],
    token_uri: data.token_uri && data.token_uri["S"]
})

const convertDataToVotingDetails = (data) => ({
    winning_option_id: data.winning_option_id["N"],
    creator: data.creator["S"],
    contract: data.contract["S"],
    inserted: data.inserted["N"],
    status: data.status["S"],
    voters: data.voters ? data.voters["SS"] : [],
    choices: data.options["SS"].map((choice, index) => ({ voteId: index, description: choice })),
    start_time: Number(data.start_time["N"]),
    description: data.description["S"],
    end_time: Number(data.end_time["N"]),
    id: data.id["S"],
    pollId: data.poll_id["N"],
    minimum_stake_time: data.minimum_stake_time["N"]
})

const timeToEpoch = (time) => {
    return Math.floor(time / 1000)
}

const formatAddress = (address) => {
    if (!address) return ""
    if (address && address.length > 20) {
        return address.substring(0, 6) + "..." + address.substring(address.length - 4, address.length)
    }
    return address
}

const formatTokenURI = (tokenURI) => {
    if (!tokenURI) return ""
    if (tokenURI && tokenURI.length > 20) {
        return tokenURI.substring(0, 24) + "..." + tokenURI.substring(tokenURI.length - 4, tokenURI.length)
    }
    return tokenURI
}

// val (str) = user's wallet balance in WEI
// wallet = wallet object
const formatBalance = (val, wallet) => {
    // returns string, rounds to 2 decimal places
    const float_val = val / 1000000000000000000 // convert wei to ETH
    let currency = "ETH"
    if (wallet) {
        // currency = KNOWN_CHAIN_CURRENCY[wallet.ethereum.networkVersion] // .networkVersion is DEPRECATED
        currency = KNOWN_CHAIN_CURRENCY[wallet.ethereum?.network?.chainId || wallet.chainId]
    }
    return float_val.toFixed(2) + ` ${currency}`
}

// adds commas/rounds to given decimal. Example:  "1234.213" => "1,234.21"
const formatNumber = (str, x = 2) => {
    var parts = str.toString().split(".") // convert str to string and create array of string(s)
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") // insert commas on left part
    if (!parts[1]) return parts[0] // if no input has no decimal, exit
    parts[1] = parts[1].substring(0, x).replace(/0+$/g, "") // cut off decimal places to x places
    if (!parts[1]) return parts[0]
    return parts.join(".")
}

const safeNumber = (str) => {
    return Number(str.substring(0, 16))
}

const formatAmount = (num, digits) => {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" }
    ]

    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
    let item = lookup
        .slice()
        .reverse()
        .find(function (item) {
            return num >= item.value
        })
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0"
}

// epoch (Unix) time = seconds since 1970, jan 1 midnight UTC
// seconds (epoch time) => string (readable date m/d/y)
// Examples:
// (1659019100) => "7/28/2022"
// (1659019100, true) => "7/28/2022, 10:38:20 AM"
const formatEpochSeconds = (seconds, showHourMinSec = true) => {
    const date = new Date(seconds * 1000)
    if (!showHourMinSec) return date.toLocaleDateString() //=> "7/28/2022"
    return date.toLocaleString() //=> '7/28/2022, 10:38:20 AM'
}

// (1234567891011) => "1,234,567,891,011" // won't work for big numbers that exceed JS number limit
// ("17247179098593886010349") => "17,247,179,098,593,886,010,349"
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

const rewardToWei = async (amount, decimals) => {
    const web3 = new Web3()
    let rewardInWei
    switch (decimals) {
        case 6:
            rewardInWei = web3.utils.toWei(amount.toString(), "mwei")
            break
        default:
            rewardInWei = web3.utils.toWei(amount.toString(), "ether")
            break
    }

    return rewardInWei
}
const rewardFromWei = async (amount, decimals) => {
    const web3 = new Web3()
    let rewardInWei
    switch (decimals) {
        case 6:
            rewardInWei = web3.utils.fromWei(amount.toString(), "mwei")
            break
        default:
            rewardInWei = web3.utils.fromWei(amount.toString(), "ether")
            break
    }

    return rewardInWei
}

const avgGasPrice = async () => {
    let gas = 95000000000

    // OLD API (NOT WORKING)
    // add average eth gas price to state after other async calls incase we error out
    // const avgGasPriceResponse = await fetch(`https://ethgasstation.info/api/ethgasAPI.json?`)
    // const avgGasPriceObj = await avgGasPriceResponse.json()
    // setAvgGasPrice(avgGasPriceObj.average * 100000000) // convert to wei, add 8 zeros

    try {
        // TO DO: Remove API Key
        const avgGasPriceResponse = await fetch(
            `https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=VFAZT67RCH5W5U6VJXIV1SBZTF3ZC362MZ`
        )
        const avgGasPriceObj = await avgGasPriceResponse.json()
        console.log("avgGasPriceObj", avgGasPriceObj.result)
        gas = avgGasPriceObj.result["SafeGasPrice"] * 1000000000 || 95000000000 // convert to wei, add 8 zeros
    } catch (error) {
        console.log(error)
    }

    return gas
}

const avgGasPricePolygon = async () => {
    let gas = 95000000000

    // OLD API (NOT WORKING)
    // add average eth gas price to state after other async calls incase we error out
    // const avgGasPriceResponse = await fetch(`https://ethgasstation.info/api/ethgasAPI.json?`)
    // const avgGasPriceObj = await avgGasPriceResponse.json()
    // setAvgGasPrice(avgGasPriceObj.average * 100000000) // convert to wei, add 8 zeros

    try {
        // TO DO: Remove API Key
        const avgGasPriceResponse = await fetch(
            `https://api.polygonscan.com/api?module=gastracker&action=gasoracle&apikey=YQBEVMA99M9X79TTH3BXBI56DTKMQYVD9H`
        )
        const avgGasPriceObj = await avgGasPriceResponse.json()
        console.log("avgGasPriceObj", avgGasPriceObj.result)
        gas = avgGasPriceObj.result["SafeGasPrice"] * 1000000000 || 95000000000 // convert to wei, add 8 zeros
    } catch (error) {
        console.log(error)
    }

    return gas
}

const fetchNFTTokens = (items, chain) => {
    let tokensCount = 0
    for (const i of items) {
        const item = convertTokenToNFTDetails(i)
        if ((item.source.includes("avalanche") && chain === 43114) || (item.source.includes("polygon") && chain === 137)) {
            tokensCount++
        }
    }
    return tokensCount
}

// returns array [start date, end date]
const setMinPollDateRange = (days) => {
    let start = new Date()
    let startCopy = new Date(start.getTime()) // make copy because .setDate modifies dat obj

    // get date 7 days from start (in milliseconds from epoch)
    let end = startCopy.setDate(startCopy.getDate() + days)

    // convert milliseconds to JS date obj
    end = new Date(end)

    return [start, end]
}

// Token Gating- flattens both community nfts AND staking nfts
// [{poolName:"", tokens:[{}, {}]}, {poolName:"", tokens:[{}, {}, {}]}, {}, {}] => [{}, {}, {}, {}] - if group has a .poolName attribute, the group is staking, else it's community
// [{name:"", tokens:[{}, {}]}, {name:"", tokens:[{}, {}, {}]}, {}, {}] => [{}, {}, {}, {}]
const flattenTokenGatingNFTs = (tokenGroups) => {
    let flattenedNFTs = []

    // loop over tokenGroups (group can either be community or staking)
    for (let i = 0; i < tokenGroups.length; i++) {
        let groupData = tokenGroups[i]

        // both groups have chain, contract, owner, and token attributes
        let nft = {
            chain: groupData.chain,
            contract: groupData.contract,
            owner: groupData.owner
        }

        // add more properties to nft depending if it is a staking nft (has .poolName), or community nft (does not have .poolName)
        if (groupData.poolName) {
            nft.poolName = groupData.poolName
            nft.poolSymbol = groupData.poolSymbol
            nft.stakedAmount = groupData.stakedAmount
        } else {
            nft.key = groupData.key
            nft.name = groupData.name
            nft.symbol = groupData.symbol
        }

        // loop over nfts in group
        for (let j = 0; j < groupData.tokens.length; j++) {
            let token = groupData.tokens[j]

            // add each token property to the nft object we are creating
            nft = { ...nft, ...token }

            flattenedNFTs.push(nft)
        }
    }

    return flattenedNFTs
}

// for use in CustomSelect chain dropdown component
const chainOptions = [
    {
        value: "avalanche", // this is what's displayed in dropdown item when selected, the value kept in react state, & sent to backend
        name: "avalanche" // this is what's displayed in dropdown item (when not selected)
    },
    {
        value: "bnbchain",
        name: "BNBChain"
    },
    {
        value: "dogechain",
        name: "dogechain"
    },
    {
        value: "ethereum",
        name: "ethereum"
    },
    {
        value: "fantom",
        name: "fantom"
    },
    {
        value: "polygon",
        name: "polygon"
    },
    {
        value: "zksync",
        name: "zksync"
    },
    {
        value: "zksynctest",
        name: "zksynctest"
    }
]

const blockchainExplorers = {
    fantom: "https://ftmscan.com/address/",
    ethereum: "https://etherscan.io/address/",
    avalanche: "https://avascan.info/blockchain/c/address/",
    binance: "https://bscxplorer.com/address/", // for projects created before 9/18/22
    bnbpremium: "https://bscxplorer.com/address/", // for survey contracts
    bnbchain: "https://bscxplorer.com/address/",
    okc: "https://exchainrpc.okex.org",
    arbitrum: "https://arbiscan.io/",
    arbitrumnova: "https://nova.arbiscan.io/",
    polygon: "https://polygonscan.com/address/",
    dogechain: "https://explorer.dogechain.dog/address/",
    zksync: "https://explorer.zksync.io/",
    zksynctest: "https://goerli.explorer.zksync.io/"
}

export {
    networkIcons,
    convertTokenToNFTDetails,
    convertTradingTokenToNFTDetails,
    convertDataToVotingDetails,
    formatAddress,
    formatTokenURI,
    formatBalance,
    formatNumber,
    safeNumber,
    formatAmount,
    formatEpochSeconds,
    rewardFromWei,
    rewardToWei,
    numberWithCommas,
    avgGasPrice,
    avgGasPricePolygon,
    fetchNFTTokens,
    timeToEpoch,
    setMinPollDateRange,
    flattenTokenGatingNFTs,
    chainOptions,
    blockchainExplorers
}
